import { Button, Grid } from "@material-ui/core";
import { useManualAutoButtonStyles } from "../../styles/useTableStyles";

interface Props {
	isManual: boolean;
}

export const ManualAutoButton = ({ isManual }: Props) => {
	const classes = useManualAutoButtonStyles();

	return (
		<Grid container justifyContent="center">
			<Grid item md={12}>
				<Button
					title={isManual ? "Manual" : "Automatic"}
					variant={"contained"}
					color={"primary"}
					className={classes.manualAutoButton}
					style={{
						cursor: "auto",
						backgroundColor: isManual ? "primary" : "green",
					}}
				>
					{isManual ? "M" : "A"}
				</Button>
			</Grid>
		</Grid>
	);
};
